module.exports = {"id":"45842","name":"Jonas Olsson","rating":"76","photo":"./data/images/photos/2/45842.png","club":{"name":"Djurgårdens IF","logo":"./data/images/clubs/DjurgardensIF.png"},"positions":["DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JonasOlsson0.json
// module id = 2088
// module chunks = 0